import React, { useRef } from 'react';
import { CarouselSection } from 'shared-components/carousel/CarouselSection';
import { CarouselSectionArrow } from 'shared-components/carousel/CarouselSectionArrow';
import { useCarouselArrows } from 'shared-components/carousel/utils/use-carousel-arrows';
import CateringPackages from '../catering-order-flow/data/catering-packages';
import { CateringPackageSlide } from './CateringPackageSlide';

export const CateringPackagesSection = ({ sectionConfig, booking }) => {
  const sliderRef = useRef();
  const { arrowDisabled, displayArrows, handleBeforeChange, onReInit } =
    useCarouselArrows(sliderRef);

  return (
    <section
      id={sectionConfig.id}
      className="catering-package-section"
      style={{ backgroundColor: sectionConfig.backgroundColor }}
    >
      <CarouselSection
        ref={sliderRef}
        onReInit={onReInit}
        beforeChange={handleBeforeChange}
        header={
          <div className="margin-lg-bottom flex space-between">
            <h3 className="no-margin tw-headline-5-b">{sectionConfig.title}</h3>
            {displayArrows && (
              <div className="flex middle" style={{ gap: '32px' }}>
                <CarouselSectionArrow
                  sliderRef={sliderRef}
                  direction="left"
                  disabled={arrowDisabled.left}
                />
                <CarouselSectionArrow
                  sliderRef={sliderRef}
                  direction="right"
                  disabled={arrowDisabled.right}
                />
              </div>
            )}
          </div>
        }
        subheader={
          <p
            className="no-margin tw-body-4"
            style={{ maxWidth: '576px', marginBottom: '40px' }}
          >
            {sectionConfig.subheader}
          </p>
        }
      >
        {[
          ...sectionConfig.packages.map((cateringPackage) => (
            <CateringPackageSlide
              key={cateringPackage.name}
              cateringPackage={cateringPackage}
              booking={booking}
            />
          )),
          sectionConfig.title === 'Instagrammable displays' && (
            <div key="catering-contact-card" className="catering-contact-card">
              <div>
                <p className="tw-headline-3-m no-margin">
                  Have a custom catering idea in mind?
                </p>

                <p className="tw-body-4 no-margin">
                  Send your request to
                  <br />
                  <a href="mailto:catering@peerspace.com">
                    catering@peerspace.com
                  </a>
                </p>
              </div>
            </div>
          )
        ].filter(Boolean)}
      </CarouselSection>
    </section>
  );
};

export const CateringPackageSections = ({ booking }) => {
  const packageSections = [
    {
      title: 'Gather & graze',
      id: 'gather-and-graze',
      subheader:
        'Take your event to the next level with a wide-ranging selection of tasty options.',
      packages: CateringPackages.slice(0, 4),
      backgroundColor: '#fff'
    },
    {
      title: 'Filling fare',
      id: 'filling-fare',
      subheader:
        'With these generous (and delicious) servings, ensure everyone will leave your event happy and well-fed.',
      packages: CateringPackages.slice(4, 8),
      backgroundColor: '#f2f2f2'
    },
    {
      title: 'Instagrammable displays',
      id: 'instagrammable-displays',
      subheader:
        'Wow your guests with culinary displays that are as beautiful as they are flavorful.',
      packages: CateringPackages.slice(8),
      backgroundColor: '#fff'
    }
  ];

  return packageSections.map((section) => (
    <CateringPackagesSection
      key={section.title}
      sectionConfig={section}
      booking={booking}
    />
  ));
};
